import React from 'react';
import { Box, Step, Typography, Stepper, StepButton } from '@mui/material';

interface CustomStep {
  id: number;
  title: string;
  subtitle: string;
}

// Define the props for StepperHeader
interface StepperHeaderProps {
  steps: CustomStep[];
  activeStep: number;
  disable?: boolean;
  completed: { [id: number]: boolean };
  onStepClick: (stepId: number) => void;
}

const StepperHeader: React.FC<StepperHeaderProps> = ({ steps, activeStep, disable, completed, onStepClick }) => (
  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
    <Stepper
      nonLinear
      activeStep={activeStep}
      sx={{
        width: '80%',
        maxWidth: { xs: '100%', sm: '100%', md: '960px', lg: '1200px' }, // responsive max widths
      }}
    >
      {steps?.map((step) => (
        <Step key={step?.id} completed={completed[step.id]} disabled={disable}>
          <StepButton color="inherit" onClick={() => onStepClick(step.id)}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <Typography variant="body1" sx={{ fontWeight: '500' }}>
                {step?.title}
              </Typography>
              <Typography variant="caption" color="text.secondary">
                {step?.subtitle}
              </Typography>
            </Box>
          </StepButton>
        </Step>
      ))}
    </Stepper>
  </Box>
);

export default StepperHeader;
